export enum DIALOG_STYLE {
  'SMALL_DIALOG' = 'small-dynamic-dialog',
  'MEDIUM_DIALOG' = 'medium-dynamic-dialog',
  'LARGE_DIALOG' = 'large-dynamic-dialog',
}
